
let WinPanelEvent = require("clover/panel/WinPanel")[2]

var FriendPvpActivityResultWaitPanel = xClass("FriendPvpActivityResultWaitPanel", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/panel_settlement1_panel_settlement.csb")
})

FriendPvpActivityResultWaitPanel.show = function (pvplogic, data, levelTime) {
    var panel = FriendPvpActivityResultWaitPanel.create(pvplogic, data, levelTime);
    panel.popup(true);


    return panel;
}

// data.time是用时，data.leftTime是剩余时间
FriendPvpActivityResultWaitPanel.prototype.ctor = function (pvplogic, data, levelTime) {
    var self = this;
    BasePanel.prototype.ctor.call(self);

    self.logic = pvplogic;
    
    var targetString = getText("pvp.settlement.content.goal").replace("{goal}", data.targetFinish + "/" + data.targetTotal);
    self.getChildByName("txt1").setString(targetString);
    self.getChildByName("txt1").width += 40;
    var scoreString = getText("pvp.settlement.content.score").replace("{score}", data.score);
    self.getChildByName("txt2").setString(scoreString);
    self.getChildByName("txt2").width += 40;
    var timeString = getText("pvp.settlement.content.time").replace("{time}", data.time);
    self.getChildByName("txt3").setString(timeString);

    var waitTxt = self.getChildByName("txt4");
    waitTxt.setContentSize(350, 30);
    waitTxt.x = self.width / 2 - 20;
    waitTxt.y -= 15;;
    waitTxt.setAnchorPoint(cc.p(0.5, 1));
    waitTxt.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
    var leftTime = data.leftTime;
    var time1 = Localhost.timeInSec();
    var refreshWaitTxt = function(){
        var leftTime1 = leftTime - (Localhost.timeInSec() - time1);
        if (leftTime1 < 0){
            waitTxt.stopAllActions();
            return;
        }
        var waitString = getText("pvp.settlement.waitted.time").replace("{time}", leftTime1);
        waitTxt.setString(waitString);
    }
    waitTxt.runAction(cc.repeatForever(cc.sequence(cc.callFunc(refreshWaitTxt), cc.delayTime(1))));

    var tip = self.getChildByName("txt_tips");
    tip.getChildByName("txt1").setString(getText("pvp.settlement.text"));
    tip.getChildByName("txt1").y -= 10;
    tip.getChildByName("icon").x += 220;
    tip.getChildByName("icon").y += 35;
    // tip.getChildByName("txt1").width = 300;
    // tip.getChildByName("txt1").x += 40;
    // tip.getChildByName("icon").y += 8;

    var finishBtn = self.getChildByName("btn_blue_finish");
    finishBtn.getChildByName("label").setString(getText("pvp.settlement.complete"));
    finishBtn.getChildByName("label").x += 10;

    
    var time = Localhost.timeInSec();
    quickBuildUIBUtton(finishBtn, () => {
        var t = Localhost.timeInSec();
        DCAssist.userTrack("PVP", "pvp_end_early", {"abtest":"new", "s_time":(t - time)});
        self.logic.finishGame();
        self.dispatchEvent({name : WinPanelEvent.Close});
    })
}

FriendPvpActivityResultWaitPanel.prototype.onCleanup = function() {
    ResManager.release(["packed/PvpSettlement1Res.pack"]);
}

FriendPvpActivityResultWaitPanel.prototype.popup = function () {
    var self = this
    var targetScale = self.getScale()
    self.setScale(0)
    var time = 7 / 30
    PopoutManager.getInstance().addWithBgFadeIn(self, true, false)
    var vSize = cc.Director.getInstance().getVisibleSize();
    var dH = display.height-GamePlayConfig_Design_Height;
    var targetPos = cc.pAdd(cc.p(self.getPosition()), cc.p(-90, 900 + dH/2));
    var pos_O = cc.p(vSize.width / 2, vSize.height / 2)
    var startPoint = cc.pMul(cc.pSub(targetPos, pos_O), 0.23)
    self.setScale(0.23)
    self.setPosition(cc.p(pos_O.x + startPoint.x, pos_O.y + startPoint.y))
    self.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(time, targetScale), cc.MoveTo.create(time, targetPos)))))
    return self
}

module.exports = FriendPvpActivityResultWaitPanel